export default __webpack_public_path__ + "static/media/logo.341ce507.svg";